/* Catalog controls do not alter cart or subscription logic. */
document.addEventListener('click',event=>{
 const button=event.target.closest('[data-v-filter]');if(!button)return;
 const catalog=button.closest('[data-v-catalog]');if(!catalog)return;
 catalog.querySelectorAll('[data-v-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
 let count=0;catalog.querySelectorAll('[data-v-category]').forEach(card=>{card.hidden=button.dataset.vFilter!=='all'&&card.dataset.vCategory!==button.dataset.vFilter;if(!card.hidden)count++;});
 const status=catalog.querySelector('.v-catalog-status');if(status)status.textContent=count+' devices shown';
});
